var themeOptions = function (theme) { return ({
    components: {
        MuiRadio: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    padding: '0 8px',
                    margin: '0 -8px',
                    height: '32px',
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=radioTheme.js.map